import {
  PanelBody,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
  __experimentalInputControl as InputControl,
  RangeControl,
  SelectControl,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import IconDisplay from "../../../../components/IconDisplay";

export default function AllInspectorSettings({ attributes, setAttributes }) {
  const {
    jumpTo,
    sectionSelector,
    position,
    icon,
  } = attributes;

  return (
    <>
      <PanelBody title={__("Settings")}>
        <ToggleGroupControl
          label={__("Jump to", "brandy-blocks")}
          value={jumpTo ?? "top"}
          isBlock
          onChange={(v) => {
            setAttributes({ jumpTo: v });
          }}
        >
          <ToggleGroupControlOption value="top" label="Top" />
          <ToggleGroupControlOption value="bottom" label="Bottom" />
          <ToggleGroupControlOption value="section" label="Section" />
        </ToggleGroupControl>
        {jumpTo === "section" && (
          <InputControl
            label={__("Section selector")}
            value={sectionSelector}
            onChange={(nextValue) =>
              setAttributes({ sectionSelector: nextValue ?? "" })
            }
          />
        )}
        <SelectControl
          label={__("Position", "brandy-blocks")}
          value={position ?? "standard"}
          onChange={(v) => {
            setAttributes({ position: v });
          }}
          options={[
            { label: "Standard", value: "standard" },
            { label: "Top Right", value: "top-right" },
            { label: "Bottom Right", value: "bottom-right" },
          ]}
          __next40pxDefaultSize={true}
        />

        <IconDisplay
          enabled={null}
          name={icon.name}
          type={icon.type}
          position={null}
          size={icon.size}
          gap={null}
          handleChangeAttributes={(updates) =>
            setAttributes({ icon: { ...icon, ...updates } })
          }
        />
      </PanelBody>
    </>
  );
}
